import { motion } from "framer-motion";
import {
    GlassWater,
    Palette,
    Mountain,
    Music2,
    Sparkles,
    Trees,
    Camera,
    Wine,
} from "lucide-react";

const AMENITIES = [
    { icon: GlassWater, title: "Atanasio Tequila Room", text: "Private tastings of Blanco, Reposado and Añejo." },
    { icon: Palette, title: "On-Site Art Gallery", text: "Rotating Van Gogh-inspired exhibitions." },
    { icon: Mountain, title: "Hill Country Vistas", text: "180° views of rolling Texas landscape." },
    { icon: Trees, title: "Outdoor Patio", text: "Stone paving and natural ceremony arch." },
    { icon: Music2, title: "Classic Piano", text: "Antique piano in the elegant main hall." },
    { icon: Sparkles, title: "Mosaic Courtyard", text: "Hand-laid Michelangelo granite mosaic." },
    { icon: Camera, title: "Bridal Suites", text: "Luminous dressing rooms with hill views." },
    { icon: Wine, title: "Catering Partners", text: "A curated roster of Hill Country chefs." },
];

export default function Amenities() {
    return (
        <section
            id="amenities"
            className="section-py container-px bg-background"
            data-testid="amenities-section"
        >
            <div className="max-w-2xl">
                <p className="overline">On the Estate</p>
                <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05]">
                    Every detail, already in place.
                </h2>
            </div>

            <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border">
                {AMENITIES.map((a, i) => (
                    <motion.div
                        key={a.title}
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: i * 0.05 }}
                        viewport={{ once: true, margin: "-40px" }}
                        className="bg-background p-8 sm:p-10 flex flex-col gap-5 hover:bg-[hsl(var(--muted))] transition-colors duration-500"
                        data-testid={`amenity-${a.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    >
                        <a.icon strokeWidth={1} className="h-8 w-8 text-[hsl(var(--primary))]" />
                        <div>
                            <h3 className="font-serif text-xl tracking-tight">{a.title}</h3>
                            <p className="mt-2 text-sm text-muted-foreground font-light leading-relaxed">
                                {a.text}
                            </p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
